export const timer = (t) => {
    if (!t || typeof t !== 'number') {
        return t;
    }

    let delta = Math.abs(t) / 1000; // переводим в секунды

    // whole days
    const days = Math.floor(delta / 86400); // 60*60*24
    //difference between seconds

    delta -= days * 86400;

    // whole hours
    const hours = Math.floor(delta / 3600) % 24; // 60*60
    //difference between seconds

    delta -= hours * 3600;

    // whole minutes
    const minutes = Math.floor(delta / 60) % 60; // 60
    const minutes_1 = minutes < 58 ? minutes+1 : minutes;
    //difference between seconds

    delta -= minutes * 60;

    // what left is seconds
    const seconds = Math.floor(delta) % 60;

    //----------------

    const daysStr = `${days}`.padStart(2, '0');
    const hoursStr = `${hours}`.padStart(2, '0');
    const minutesStr = `${minutes_1}`.padStart(2, '0');
    const secondsStr = `${seconds}`.padStart(2, '0');

    return {
        days:    daysStr,
        hours:   hoursStr,
        minutes: minutesStr,
        seconds: secondsStr,
    };

};
